import script from "./LoginComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginComponent.vue?vue&type=script&lang=ts&setup=true"

import "./LoginComponent.vue?vue&type=style&index=0&id=3b563e6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b563e6a"]])

export default __exports__